'use client';

import type { CtaContentProps } from './cta-content';
import dynamic from 'next/dynamic';
import CtaLink from './cta-link';

const DynamicCta = dynamic(() => import('@/components/ui/cta-button/cta-button'), {
  // ssr: false,
  loading: () => <CtaLink />,
});

export default function CtaButton(props: CtaContentProps) {
  return <DynamicCta {...props} />;
}
